import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../../barcodeform.css';

import Select from 'react-select';
import jQuery from 'jquery';
import { CSVLink } from 'react-csv';
import * as XLSX from 'xlsx';
import { getApiBaseUrl } from '../../utils/utils'; 
import ExportWizard from './export/ExportWizard';
import { daysInRange, fetchOrders } from './export/exportEngine';

/**
 * One export-wizard row in the shape this page has always rendered and exported. The data now comes
 * from GET /jobs/export/rows a day at a time: every order in the range (by order date unless asked
 * otherwise), instead of one heavy request that only returned orders assigned to a driver.
 * COD / cash are only set for COD orders, exactly as the old report did.
 */
const toAccountsShape = (r) => {
    const cod = String(r.paymentType || '').toUpperCase() === 'COD';
    return {
        bookingId: r.awb,
        custAwb: r.businessRefNo,
        assignedDate: r.assignedAt,
        createdAt: r.createdAt,
        city: r.city,
        type: r.legType,
        paymentType: r.paymentType,
        codDetails: cod ? (r.codAmount || 0) : 0,
        cashCollected: cod ? (r.cashCollected || 0) : 0,
        lastUpdatedDate: r.lastUpdatedAt,
        latestStatus: r.status || '',
        masterAwbNumber: r.masterAwbNumber,
        consolidatedWeight: r.weight,
        projectName: r.projectName,
        serviceTime: r.serviceTime,
        itemSummary: r.itemSummary,
        orderValue: r.orderValue,
        isJewellery: r.isJewellery,
        scanTime: r.scannedAt,
        childAwbs: r.childAwbs,
        dutiesTax: r.dutiesTax,
        operationalAddon: r.operationalAddon,
        totalCollected: r.totalCollected,
        collectionFlow: r.collectionFlow,
        courier: r.driverName || (r.driverId ? `#${r.driverId}` : ''),
        courierTeam: r.driverTeam || '',
        courierZone: r.driverZone || '',
        updatedBy: r.updatedBy,
        shipperDetails: { name: r.shipperName, address: r.shipperAddress, phone: r.shipperPhone },
        consigneeDetails: { name: r.consigneeName, address: r.consigneeAddress, phone: r.consigneePhone },
    };
};

// "yyyy-MM-dd HH:mm:ss" -> parts; never throws on a missing value (the old new Date(x).toISOString() did).
const tsDate = (ts) => (ts ? String(ts).slice(0, 10) : '');
const tsTime = (ts) => (ts && String(ts).length > 11 ? String(ts).slice(11, 19) : '');

export default function AccountsReport() {

    const API_URL = process.env.REACT_APP_API_URL;
    const [barcode, setBarcode] = useState('');
    const [shipmentDetails, setShipmentDetails] = useState([]);
    const [loading, setLoading] = useState(false);

    const $ = jQuery.noConflict();


    const [selectedPaymentType, setSelectedPaymentType] = useState('All');
    useEffect(() => {



        $(".btn-demo.import").on('click', function () {
            $('.nalier.middle-center.fade').css("display", "block");
            $('.nalier.middle-center.fade').addClass("in");
        });

        $(".close.h-close").on('click', function () {
            $('.nalier.middle-center.fade.in').css("display", "none");
            $('.nalier.middle-center.fade').removeClass("in");
        });



    }, []);

    const buttonsyle = {
        background: '#00a6ed',
        color: '#fff',
        padding: '3px',
        marginRight: '10px',
        borderColor: '#00a6ed',
        cursor: 'pointer',
        marginTop: '3%'
    }
    const buttonsyle1 = {
        background: '#00a6ed',
        color: '#fff',
        padding: '3px',
        marginLeft: '75%',
        borderColor: '#00a6ed',
        cursor: 'pointer',
        marginTop: '3%',
        marginBottom: '2%'
    }


    const [msg, setMsg] = useState('')
    const [errormsg, setError] = useState('')

    useEffect(() => {
        // Fetch drivers from the API on component mount
        fetchDrivers();
        getUserList();

    }, []);

    const [scaninfo, setScaninfo] = useState({
        driver: ''
    })
    const [drivers, setDrivers] = useState()
    const [awb, setAwb] = useState();
    const fetchDrivers = async () => {
        try {
            // Replace this API endpoint with the actual one that fetches drivers based on the emirate
            const response = await axios.get(`${API_URL}shypvdriverapp/driver/getAllDrivers`);

            if (response.data.success) {
                const driversData = response.data.data;  // The array of driver objects

                // Map the response to extract driverId and name
                const driversList = driversData.map(driver => ({
                    driver_id: driver.driverId,
                    driver_name: driver.name
                }));

                // Set the drivers state
                setDrivers(driversList);
            } else {
                console.error('Error fetching drivers for emirate:');
            }
        } catch (error) {
            console.error('Error fetching drivers:', error);
        }
    };

    const [users, setusers] = useState()
    const getUserList = async () => {
        const API_PATH = `${API_URL}shypvdriverapp/personnel/getPersonnels`;

        // Send a GET request to the new API
        try {
            const res = await axios.get(API_PATH);

            console.log(res.data);  // Log the response to inspect it

            // Check if the response contains 'data' and if it's an array
            if (res.data && res.data.success && Array.isArray(res.data.data)) {
                setusers(res.data.data);  // Update the personnel list in the state
            } else {
                console.log('No personnel data found in the response or response is not successful');
            }



        } catch (err) {
            console.log('Error fetching personnel list:', err);

        }
    };

    console.log('drivers:', drivers)
    console.log('scan:', scaninfo)
    console.log('users:', users)


     const [partners, setPartners] = useState([]);
        useEffect(() => {
            const fetchPartners = async () => {
    
                const baseApiUrl = getApiBaseUrl();
                try {
                    const response = await axios.get(`${baseApiUrl}/v1.0/partner/retrieve_list?page=0`);
                    setPartners(response.data.data)
                       
    
                } catch (err) {
                    setError(err.message || 'Error fetching data');
                } finally {
                    // setLoading(false);
                }
            };
    
            fetchPartners();
        }, []);

 const [selectedPartner, setSelectedPartner] = useState('0');
    const [exportFormat, setExportFormat] = useState('excel'); // 'excel' | 'csv'
    const [dateBasis, setDateBasis] = useState('ORDER_DATE');
    const [exportOpen, setExportOpen] = useState(false);
    // { running, daysDone, daysTotal, rows, failedDays: [{day, error}] }
    const [loadState, setLoadState] = useState(null);

    // Export the given rows (already header-shaped, e.g. from generateCSVData) as .xlsx or .csv,
    // honouring the selected format and the csvHeaders column order.
    const orderedRow = (row) => {
        const out = {};
        csvHeaders.forEach((h) => { out[h.label] = row[h.key] !== undefined ? row[h.key] : ''; });
        return out;
    };
    const downloadReport = (rows, baseName) => {
        if (!rows || rows.length === 0) { setError('Nothing to export.'); return; }
        const shaped = rows.map(orderedRow);
        const ws = XLSX.utils.json_to_sheet(shaped);
        if (exportFormat === 'csv') {
            const csv = XLSX.utils.sheet_to_csv(ws);
            const blob = new Blob(["﻿" + csv], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url; a.download = `${baseName}.csv`; a.click();
            URL.revokeObjectURL(url);
        } else {
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Accounts');
            XLSX.writeFile(wb, `${baseName}.xlsx`);
        }
    };

    const handleSelectChange = (e) => {
        const partnerId = e.target.value;

        if (partnerId === '0') {
            setSelectedPartner('0');

            return;
        }

        const partner = partners.find((p) => String(p.pid) === partnerId);
        setSelectedPartner(partner.pid);


    };

    // Loads the report a day at a time (GET /jobs/export/rows), so a long range never becomes one
    // heavy query, and a day that fails is listed for retry instead of silently missing.
    const loadDays = async (days, keep) => {
        const filters = {
            dateBasis,
            legType: 'DROP',
            partnerId: (selectedPartner && selectedPartner !== '0') ? String(selectedPartner) : '0',
        };
        setLoading(true);
        setError('');
        setLoadState({ running: true, daysDone: 0, daysTotal: days.length, rows: 0, failedDays: [] });
        const res = await fetchOrders({
            apiUrl: API_URL,
            days,
            filters,
            include: ['shipper', 'driver', 'duties', 'custody', 'updatedBy'],
            onProgress: (p) => setLoadState((st) => ({ ...st, daysDone: p.daysDone, daysTotal: p.daysTotal, rows: p.rows })),
        });
        const byDay = { ...(keep || {}), ...res.rowsByDay };
        const all = daysInRange(datechosenfrom, datechosento).flatMap((d) => byDay[d] || []);
        setShipmentDetails(all.map(toAccountsShape));
        setLoadState({ running: false, daysDone: days.length, daysTotal: days.length, rows: all.length, failedDays: res.failedDays, byDay });
        setLoading(false);
        if (res.failedDays.length) setError(`${res.failedDays.length} day(s) could not be loaded - use "Retry" before downloading.`);
        else if (!all.length) setError('Booking details not found');
    };

    const getDetails = async () => {
        if (!datechosenfrom || !datechosento) { setError('Pick both dates first'); return; }
        if (datechosento < datechosenfrom) { setError('"To Date" is before "Date"'); return; }
        try {
            await loadDays(daysInRange(datechosenfrom, datechosento), null);
        } catch (err) {
            console.error('Error:', err?.response || err?.message);
            setLoading(false);
            setError('An error occurred while fetching details');
        }
    };

    const retryFailed = () => {
        if (!loadState?.failedDays?.length) return;
        loadDays(loadState.failedDays.map((f) => f.day), loadState.byDay);
    };

    const [driverdata, setdriverdata] = useState({
        driverid: '',
        team: '',
        zone: ''

    })

    const fetchDriverInfo = async (driverId) => {
        try {
            const response = await axios.get(`${API_URL}shypvdriverapp/driver/getDriver`, {
                params: { driverId }
            });

            console.log('Driver Info:', response.data);
            if (response.data.success) {
                const driverInfo = response.data.data;

                setdriverdata({
                    driverid: driverInfo.driverId || '',
                    team: driverInfo.team?.teamName || '',
                     zone: `${driverInfo.zone?.district || ''} - ${driverInfo.zone?.emirates || ''}`
                });
            } else {
                setdriverdata({ driverid: driverId, team: '', zone: '' });
            }
         

        } catch (error) {
            console.error('Error fetching driver info:', error);
            setdriverdata({ driverid: driverId, team: '', zone: '' });
        }
    };


  

  



    const [allStatus, setallStatus] = useState()
    useEffect(() => {
        // Make the API call when the component mounts
        axios
            .get(`${API_URL}shypvdriverapp/jobs/getAllStatus`)
            .then((response) => {
                setallStatus(response.data.data);  // Store the data in state
                setLoading(false);        // Set loading to false when done
            })
            .catch((err) => {
                setError(err);            // Store the error in state if something goes wrong
                setLoading(false);        // Set loading to false even if there's an error
            });
    }, []);

    console.log('all', allStatus)

    //   const [updatedDetails, setUpdatedDetails] = useState(shipmentDetails);
 
    console.log('shipmentDetails', shipmentDetails)


    const [datechosenfrom, setdatechosenfrom] = useState()
    const [datechosento, setdatechosento] = useState()
    const [driver, setdriverchosen] = useState()

    const handleFilterChange = (e) => {
        setSelectedPaymentType(e.target.value);
    };

    const filteredShipmentDetails = shipmentDetails.filter((data) => {

        if (selectedPaymentType === 'COD') {
            return data.paymentType === selectedPaymentType; // Filter by COD or NON COD
        } else if (selectedPaymentType === 'NON COD') {
            return data.paymentType !== 'COD'; // Filter by COD or NON COD
        }
        else if (selectedPaymentType === 'DELIVERED') {
            return data.latestStatus === 'DELIVERED'; // Filter by COD or NON COD
        } else if (selectedPaymentType === 'PENDING') {
            return data.latestStatus !== 'DELIVERED'; // Filter by COD or NON COD
        }
        else {
            return true; // Show all
        }

    });


    const totalCod = filteredShipmentDetails && filteredShipmentDetails.filter(data => data.latestStatus?.toLowerCase() === 'delivered').reduce((acc, data) => acc + (parseFloat(data.codDetails) || 0), 0);

    const [actualCollectedMap, setActualCollectedMap] = useState({});

    // Update actualCollectedMap when the component mounts
    useEffect(() => {
        const initialMap = {};
        filteredShipmentDetails.forEach((item) => {
            initialMap[item.bookingId] = item.cashCollected ?? 0;
        });
        setActualCollectedMap(initialMap);
    }, [filteredShipmentDetails]);

    // Calculate the sum of all values in actualCollectedMap
    const getTotalActualCollected = () => {
        return filteredShipmentDetails.filter(data => data.latestStatus?.toLowerCase() === 'delivered').reduce((sum, data) => {
            const collectedAmount = actualCollectedMap[data.bookingId];
            return sum + (collectedAmount ? parseFloat(collectedAmount) : 0); // Safely sum the values
        }, 0);
    };


    const generateCSVData = (type) => {
        // Filter data based on the passed type
        let filteredData = shipmentDetails;

        if (type === "DELIVERED") {
            console.log('dele')
            filteredData = shipmentDetails.filter((data) => data.latestStatus === "DELIVERED");
        } else if (type === "PENDING") {
            // filteredData = shipmentDetails.filter((data) => data.paymentType !== "COD");
            filteredData = shipmentDetails.filter((data) => data.latestStatus !== "DELIVERED");
            //   filteredData = shipmentDetails.filter((data) => data.latestStatus && data.latestStatus.trim().toUpperCase() !== "DELIVERED");
        }
        else if (type === "nonCOD") {
            filteredData = shipmentDetails.filter((data) => data.paymentType !== "COD");
        }
        else if (type === "COD") {
            filteredData = shipmentDetails.filter((data) => data.paymentType === "COD");
        }
        else {
            filteredData = shipmentDetails
        }



        const csvData = filteredData.map((data) => ({
            // ── Added fields (match the Live View / Emirates export layout) ──
            CustawbNo: data.custAwb || '',
            TimexAWB: data.bookingId || '',
            City: data.city || '',
            Destination: data.city || '',
            Type: data.type || '',
            "Task Status": data.latestStatus || '',
            "Assigned Date": tsDate(data.assignedDate),
            "Order Creation Date": tsDate(data.createdAt),
            SRVTYPE: '',                 // sourced from the Emirates payload — pending
            TOC: '',                     // sourced from the Emirates payload — pending
            AWB: data.bookingId,
            Status: data.latestStatus,
            "Last Transit Date": tsDate(data.lastUpdatedDate),
            "Last Transit Time": tsTime(data.lastUpdatedDate),
            Courier: data.courier || '',
            courier_team: data.courierTeam || '',
            courier_zone: data.courierZone || '',
            Shipper: data.shipperDetails?.name || '',
            Consignee: data.consigneeDetails?.name || '',
            "Payment Type": data.paymentType,
            COD: data.latestStatus?.toLowerCase() === 'delivered' ? data.codDetails : 0,
            "Cash Collected": data.latestStatus?.toLowerCase() === 'delivered' ? data.cashCollected : '',
            "Cash Difference": data.latestStatus?.toLowerCase() === 'delivered' ? (data.codDetails - data.cashCollected) : 0,

            "Updated By": data.updatedBy,
            "Duties & Tax": data.dutiesTax != null ? data.dutiesTax : 0,
            "Operational Addon": data.operationalAddon != null ? data.operationalAddon : 0,
            "Total Collected (COD+Duties)": data.totalCollected != null ? data.totalCollected : 0,
            "Collection Flow": data.collectionFlow || '',
            "Scan Time": data.scanTime || '',
            "Multishipment AWB": data.masterAwbNumber || '',
            "Child AWBs": data.childAwbs || '',
            "Overall Weight": data.consolidatedWeight != null ? data.consolidatedWeight : '',
            "Project": data.projectName || '',
            "Service Time": data.serviceTime || '',
            "Item Summary": data.itemSummary || '',
            "Item Value": data.orderValue != null ? data.orderValue : '',
            "Is Jewellery": data.isJewellery === true ? 'Yes' : data.isJewellery === false ? 'No' : '',
        }));


        const totalCodcsv = filteredData && filteredData.filter(data => data.latestStatus?.toLowerCase() === 'delivered').reduce((acc, data) => acc + (parseFloat(data.codDetails) || 0), 0);

        // Add the Total COD as a row at the end of the CSV
        const csvDataWithTotal = [
            ...csvData,
            ...(type && type !== 'nonCOD'
                ? [{
                    AWB: 'Total COD:',
                    Status: '',
                    "Last Transit Date": '',
                    "Last Transit Time": '',
                    Courier: '',
                    courier_team: '',
                    courier_zone: '',
                    Shipper: '',
                    Consignee: '',
                    "Payment Type": '',
                    COD: totalCodcsv, // Add totalCod only if it's not 'NON COD'
                    ActualCollected: getTotalActualCollected(),
                    "Updated By": '',
                    "Multishipment AWB": '',
                    "Overall Weight": '',
                    "Project": '',
                    "Service Time": '',
                    "Item Summary": '',
                    "Item Value": '',
                    "Is Jewellery": '',
                },

                ]
                : []),
        ];

        // Returning the result

        return csvDataWithTotal;
    };


    // Add the Total COD as a row at the end of the CSV


    // CSV headers
    const csvHeaders = [
        // ── Emirates / Live-View layout columns ──
        { label: "CustawbNo", key: "CustawbNo" },
        { label: "TimexAWB", key: "TimexAWB" },
        { label: "Last Transit Date", key: "Last Transit Date" },
        { label: "Order Creation Date", key: "Order Creation Date" },
        { label: "Task Status", key: "Task Status" },
        { label: "Customer Name", key: "Consignee" },
        { label: "City", key: "City" },
        { label: "Shipper", key: "Shipper" },
        { label: "Driver", key: "Courier" },
        { label: "Driver Team", key: "courier_team" },
        { label: "Driver Zone", key: "courier_zone" },
        { label: "AWB", key: "CustawbNo" },
        { label: "Weight", key: "Overall Weight" },
        { label: "Destination", key: "Destination" },
        { label: "Status", key: "Status" },
        { label: "Type", key: "Type" },
        { label: "Assigned Date", key: "Assigned Date" },
        { label: "SRVTYPE", key: "SRVTYPE" },
        { label: "TOC", key: "TOC" },
        // ── Accounts add-ons ──
        { label: "Last Transit Time", key: "Last Transit Time" },
        { label: "Courier", key: "Courier" },
        { label: "Courier team", key: "courier_team" },
        { label: "Courier zone", key: "courier_zone" },
        { label: "Consignee", key: "Consignee" },
        { label: "Payment Type", key: "Payment Type" },
        { label: "COD", key: "COD" },
        { label: "Cash Collected", key: "Cash Collected" },
        { label: "Cash Difference", key: "Cash Difference" },
        { label: "Updated By", key: "Updated By" },
        { label: "Duties & Tax", key: "Duties & Tax" },
        { label: "Operational Addon", key: "Operational Addon" },
        { label: "Total Collected (COD+Duties)", key: "Total Collected (COD+Duties)" },
        { label: "Collection Flow", key: "Collection Flow" },
        { label: "Scan Time", key: "Scan Time" },
        { label: "Multishipment AWB", key: "Multishipment AWB" },
        { label: "Child AWBs", key: "Child AWBs" },
        { label: "Overall Weight", key: "Overall Weight" },
        { label: "Project", key: "Project" },
        { label: "Service Time", key: "Service Time" },
        { label: "Item Summary", key: "Item Summary" },
        { label: "Item Value", key: "Item Value" },
        { label: "Is Jewellery", key: "Is Jewellery" },
    ];


    const csvDataForDownload = generateCSVData('DELIVERED');  // Replace with 'pending' for pending records
    const csvDataForDownloadAll = generateCSVData('ALL');  // Replace with 'pending' for pending records
    const csvDataForDownloadPending = generateCSVData('PENDING');  // Replace with 'pending' for pending records
    const csvDataForNonCod = generateCSVData('nonCOD');  // Replace with 'pending' for pending records
    const csvDataForCOD = generateCSVData('COD');  // Replace with 'pending' for pending records

    const hasDeliveredRecords = shipmentDetails.some((data) => String(data.latestStatus || '').toUpperCase() === "DELIVERED");



    // Handle filter change



   

    return (
        <div>
            <div className="form-container">
                <h4>Get Report</h4>
                <div className="row">
                    <div className="col-md-8">
                        <div className="row">
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label htmlFor="driver">Date:</label>
                                    <input type="date"
                                        id="date"
                                        value={datechosenfrom}
                                        onChange={(e) => setdatechosenfrom(e.target.value)}

                                    />


                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="form-group">
                                    <label htmlFor="dateBasis">Dates are:</label>
                                    <select id="dateBasis" value={dateBasis} onChange={(e) => setDateBasis(e.target.value)}>
                                        <option value="ORDER_DATE">Order date (all orders)</option>
                                        <option value="ASSIGNED_DATE">Assigned date (assigned only)</option>
                                    </select>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="form-group">
                                    <label htmlFor="driver">To Date:</label>
                                    <input type="date"
                                        id="date"
                                        value={datechosento}
                                        onChange={(e) => setdatechosento(e.target.value)}

                                    />


                                </div>
                            </div>
                        </div>


                        {/* Driver Selection */}
                        <div className="row">
                            <div className="col-md-8">


                              
                                <div className="form-group">
                                    <label htmlFor="formGroupExampleInput2" className="m-form">Partner*</label>
                                    <select onChange={handleSelectChange} value={selectedPartner} style={{ marginRight: '10px' }}>
                                        <option value="" disabled>
                                            -- Select a partner --
                                        </option>
                                        <option value="0">All</option>
                                        {partners && [...partners].sort((a, b) => a.pname.localeCompare(b.pname)).map((partner) => (
                                            <option key={partner.pid} value={partner.pid}>
                                                {String(partner.pid).padStart(2, '0')} - {partner.pname}
                                            </option>
                                        ))}
                                    </select>

                                </div>
                                {/* <div className="form-group">
                                    <label htmlFor="driver">Select Driver:</label>
                                    <select
                                        id="driver"
                                        value={driver}
                                        onChange={(e) => setdriverchosen(e.target.value)}

                                    >
                                        <option value="">Select a driver</option>
                                        {drivers && drivers.map((driver) => (
                                            <option key={driver.driver_id} value={driver.driver_id}>
                                                {driver.driver_name}
                                            </option>
                                        ))}
                                    </select>
                                </div> */}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-3">


                            </div>
                            <div className="col-md-6">
                                <a onClick={loadState?.running ? undefined : getDetails} style={{ ...buttonsyle, opacity: loadState?.running ? 0.6 : 1 }} type="button" className="btn-demo add">
                                    {loadState?.running ? 'Loading…' : 'Submit'}
                                </a>
                                <button type="button" onClick={() => setExportOpen(true)}
                                    title="Export wizard - pick filters and columns, download every matching order"
                                    style={{ marginLeft: 10, background: '#1e3a8a', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 14px', fontWeight: 600, cursor: 'pointer' }}>
                                    <i className="fa fa-file-excel-o" /> Export wizard
                                </button>
                                {loadState && (loadState.running || loadState.failedDays?.length > 0) && (
                                    <div style={{ marginTop: 10, fontSize: 13, color: '#334155' }}>
                                        {loadState.running
                                            ? <span><i className="fa fa-spinner fa-spin" /> Loaded {loadState.daysDone}/{loadState.daysTotal} days · {loadState.rows.toLocaleString()} orders…</span>
                                            : <span style={{ color: '#92400e' }}>
                                                {loadState.failedDays.length} day(s) failed: {loadState.failedDays.map((f) => f.day).join(', ')}{' '}
                                                <button type="button" onClick={retryFailed} style={{ marginLeft: 6, border: '1px solid #d97706', background: '#fff', color: '#92400e', borderRadius: 6, padding: '2px 10px', cursor: 'pointer' }}>Retry</button>
                                              </span>}
                                    </div>
                                )}

                            </div>
                        </div>
                        <p style={{ color: 'red', marginTop: '2%' }}>{errormsg}</p>
                    </div>
                    <div className="col-md-4">
                        {shipmentDetails.length > 0 && (
                            <div className="row">
                                <div className="col-md-11">
                                    {/* Use inline-block for alignment */}
                                    <div className="text-right">
                                        {/* Format selector: Excel or CSV */}
                                        <div className="inline-block" style={{ marginRight: '12px', marginBottom: '5px' }}>
                                            <label style={{ fontSize: 12, marginRight: 4, color: '#555' }}>Format:</label>
                                            <select value={exportFormat} onChange={(e) => setExportFormat(e.target.value)}
                                                style={{ fontSize: 12, padding: '2px 6px' }}>
                                                <option value="excel">Excel (.xlsx)</option>
                                                <option value="csv">CSV (.csv)</option>
                                            </select>
                                        </div>

                                        {/* Delivered */}
                                        {hasDeliveredRecords && (
                                            <div className="inline-block" style={{ marginRight: '10px', marginBottom: '5px' }}>
                                                <button type="button" className="btn btn-link text-primary font-weight-bold p-0"
                                                    onClick={() => downloadReport(csvDataForDownload, 'shipment_details_delivered')}>
                                                    <i className="fa fa-download" /> Delivered
                                                </button>
                                            </div>
                                        )}

                                        {/* Pending */}
                                        <div className="inline-block" style={{ marginRight: '10px', marginBottom: '5px' }}>
                                            <button type="button" className="btn btn-link text-primary font-weight-bold p-0"
                                                onClick={() => downloadReport(csvDataForDownloadPending, 'shipment_details_pending')}>
                                                <i className="fa fa-download" /> Pending
                                            </button>
                                        </div>

                                        {/* COD */}
                                        <div className="inline-block" style={{ marginRight: '10px', marginBottom: '5px' }}>
                                            <button type="button" className="btn btn-link text-primary font-weight-bold p-0"
                                                onClick={() => downloadReport(csvDataForCOD, 'shipment_details_cod')}>
                                                <i className="fa fa-download" /> COD
                                            </button>
                                        </div>

                                        {/* Non COD */}
                                        <div className="inline-block" style={{ marginRight: '10px', marginBottom: '5px' }}>
                                            <button type="button" className="btn btn-link text-primary font-weight-bold p-0"
                                                onClick={() => downloadReport(csvDataForNonCod, 'shipment_details_non_cod')}>
                                                <i className="fa fa-download" /> Non COD
                                            </button>
                                        </div>

                                        {/* All */}
                                        <div className="inline-block" style={{ marginRight: '10px', marginBottom: '5px' }}>
                                            <button type="button" className="btn btn-link text-primary font-weight-bold p-0"
                                                onClick={() => downloadReport(csvDataForDownloadAll, 'shipment_details')}>
                                                <i className="fa fa-download" /> All
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>





                </div>








                <div className="row">
                    <div className="col-md-11">
                        {loading && <p>Loading shipment details...</p>}

                        {shipmentDetails.length > 0 && (
                            <div>
                                {/* <div className="row">
                                    <div className="col-12 d-flex justify-content-end" style={{ float: 'right' }}>
                                        <div className="row">
                                            <div className="col-md-4" style={{ marginRight: '10%' }}>
                                                {hasDeliveredRecords && (
                                                    <CSVLink
                                                        data={csvDataForDownload}
                                                        headers={csvHeaders}
                                                        filename="shipment_details.csv"
                                                        className="btn btn-primary"
                                                        style={{ marginRight: '10px', marginBottom: '5px' }}
                                                    >
                                                        <i className="fa fa-download" /> Delivered
                                                    </CSVLink>
                                                )}
                                            </div>
                                            <div className="col-md-4">
                                                <CSVLink
                                                    data={csvDataForDownloadPending}
                                                    headers={csvHeaders}
                                                    filename="shipment_details.csv"
                                                    className="btn btn-primary"
                                                    style={{ marginBottom: '5px' }}
                                                >
                                                    <i className="fa fa-download" /> Pending
                                                </CSVLink>
                                            </div>


                                        </div>



                                    </div>
                                </div> */}




                                <h4 style={{ textAlign: 'left' }}>Track Summary:</h4>
                                <div className="row">
                                    <div className="col-md-4" style={{ float: 'right' }}>
                                        <select style={{ float: 'right', marginBottom: '3%' }} onChange={handleFilterChange}>
                                            <option value="All">All</option>
                                            <option value="COD">COD</option>
                                            <option value="NON COD">NON COD</option>
                                            <option value="DELIVERED">Delivered</option>
                                            <option value="PENDING">Pending</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="shipdata" style={{
                                    background: '#5583af59',
                                    maxHeight: '500px', // Adjust the height limit as needed
                                    overflowY: 'auto',  // Enables vertical scrolling
                                    // padding: '10px',   // Optional: Add some padding for better visuals
                                    border: '1px solid #ccc',// Optional: Add a border for separation
                                    // marginBottom:'3%'
                                }}>
                                    <table className='table  table-bordered table-striped'>
                                        <thead>
                                            <tr>
                                                <th>AWB</th>
                                                <th>Status</th>
                                                <th>Last Transit Date</th>
                                                <th>Last Transit Time</th>
                                                <th>Courier</th>
                                                <th>Courier Team</th>
                                                <th>Courier Zone</th>
                                                <th>Shipper</th>
                                                <th>Consignee</th>

                                                <th>Payment Type</th>
                                                <th>COD</th>
                                                <th>Cash Collected</th>
                                                <th>Cash Difference</th>
                                                <th>Updated By</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredShipmentDetails.map((data, index) => (
                                                <tr key={index}>
                                                    <td> {data.bookingId}
                                                        <br />
                                                        <p
                                                            style={{
                                                                display: 'inline-block',
                                                                width: '15px',
                                                                height: '15px',
                                                                borderRadius: '50%',
                                                                backgroundColor: data.type === 'PICK_UP' ? 'blue' : data.type === 'DROP' ? 'green' : 'gray',
                                                                color: 'white',
                                                                textAlign: 'center',
                                                                lineHeight: '15px',  // To center the text vertically
                                                                fontSize: '10px',
                                                                fontWeight: 'bold',
                                                            }}
                                                        >
                                                            {data.type === 'PICK_UP' ? 'P' : data.type === 'DROP' ? 'D' : ''}
                                                        </p>
                                                    </td>
                                                    <td>{data.latestStatus}</td>
                                                    {/* <td>{new Date(data.lastUpdatedDate).toLocaleDateString()}</td> */}
                                                    <td style={{ width: '150px' }}>{tsDate(data.lastUpdatedDate)}</td>

                                                    <td>{tsTime(data.lastUpdatedDate)}</td>

                                                    <td>{data.courier || ''}</td>

                                                    <td>{data.courierTeam}</td>
                                                    <td>{data.courierZone}</td>
                                                    <td>{data.shipperDetails?.name || ''}</td>
                                                    <td>{data.consigneeDetails?.name || ''}</td>

                                                    <td>{data.paymentType}</td>
                                                    <td>{data.latestStatus?.toLowerCase() === 'delivered' ? data.codDetails : 0}</td>
                                                    <td>{data.latestStatus?.toLowerCase() === 'delivered' ? data.cashCollected : 0}</td>
                                                    <td>{data.latestStatus?.toLowerCase() === 'delivered' ? (data.codDetails - data.cashCollected) : 0}</td>
                                                    <td>{data.updatedBy}</td>


                                                </tr>
                                            ))}
                                        </tbody>
                                        {selectedPaymentType !== 'NON COD' ? (
                                            <tfoot style={{ background: '#fff' }}>
                                                <tr>
                                                    <td colSpan="11" style={{ textAlign: 'right', fontWeight: 'bold' }}>
                                                        Total COD:
                                                    </td>
                                                    <td>{totalCod}</td>

                                                </tr>
                                                <tr>
                                                    <td colSpan="11" style={{ textAlign: 'right', fontWeight: 'bold' }}>
                                                        Actual Collected:
                                                    </td>
                                                    <td>{getTotalActualCollected()}</td>

                                                </tr>
                                            </tfoot>
                                        ) : ('')}

                                    </table>

                                </div>


                            </div>


                        )}

                    </div>
                </div>
            </div>



            <ExportWizard
                open={exportOpen}
                onClose={() => setExportOpen(false)}
                context="accounts"
                title="Export accounts report"
                partners={partners || []}
                initialFilters={{
                    fromDate: datechosenfrom,
                    toDate: datechosento,
                    partnerId: selectedPartner,
                    dateBasis,
                    legType: 'DROP',
                }}
                defaultPreset="accounts"
            />
        </div>
    );
};

